import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { UserManagerService } from './shared/services/api';
import { AppStateService } from './shared/services/app-state.service';
import { ContentObserver } from '@angular/cdk/observers';
import { MultiAuthService } from './shared/services/multi-auth-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'merlin-ui';

  constructor(private auth: AuthService,
    private router: Router,
    private appState:AppStateService,
    private toastr:ToastrService,
    private userService:UserManagerService,
    private multiple: MultiAuthService) {

  }

  async ngOnInit(): Promise<void> {
      this.auth.isAuthenticated$.subscribe(async result => {
        this.userService.userManagerGetLoggedInUserInfoGet().pipe(first()).subscribe(user=>{
          this.appState.setUser(user);
          console.log("current state",this.appState);
          if(this.router.url.includes("login")){
            if (user.isAdmin) {
              this.router.navigate(["/admin/dashboard"]);
            }else{
              if(this.appState.user.jobTitle == "Essay Judge"){
                this.router.navigate(["/judge/eval"]);
                return;
              }
              if(this.appState.user.contactType === 'Teacher'){
                this.router.navigate(["/teacher/essays"]);
                return;
              }
              this.router.navigate(["/user/map"]);
            }
          }

        },err=>{
        if(err.status == 401){
          this.toastr.error("You are not Authorized.")

          this.auth.logout({ returnTo: location.protocol + "//" + location.host });
        }
        });
      });
    }
}

